// Dev-only warning helper. Production builds strip these at minification time.
export function warn(...args) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
}
